/**
 * IS THIS SIGN-IN THE DANCER HERSELF? One answer, for the browser and for the
 * Netlify Functions alike (bag group plan v2, section 3.0).
 *
 * A dancer's own sign-in is any of:
 *  - her child login on a family account (role family, or a missing role,
 *    carrying her studentId). The same expression as userIsDancerAccount in
 *    netlify/functions/lib/communityAccess.mjs and isDancerLoginUserDoc in
 *    ./users.ts, both of which call a Jr Staff email account "not a dancer";
 *  - a Jr Staff sign-in that isOwnJrStaffSignIn admits: her email staff
 *    account or her promoted dancer login (active, role ensemble, carrying
 *    her studentId), or her unpromoted dancer login (status dancer).
 *
 * A Jr Staff is ONE PERSON however she signs in (Bobbie, 2026-09-07), so a
 * gate that used userIsDancerAccount alone would treat her two sign-ins
 * differently. Use this instead wherever the question is "is this the dancer".
 *
 * Pure on purpose: no Firebase import, so a Netlify Function can import this
 * file the way lib/jrStaffAliasUids.mjs imports ./jrStaffAliases.ts.
 */
import { isOwnJrStaffSignIn, type JrStaffAliasAccount } from './jrStaffAliases.ts';

const STAFF_ROLES = ['director', 'manager', 'company', 'ensemble', 'foh'];

export interface SelfSignInAccount {
  role?: unknown;
  status?: unknown;
  studentId?: unknown;
}

function text(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

/** The child login on a family account. Kept identical to userIsDancerAccount. */
export function isDancerChildLogin(account: SelfSignInAccount | null | undefined): boolean {
  return text(account?.studentId).length > 0
    && !STAFF_ROLES.includes(String(account?.role ?? ''));
}

/** Any of the dancer's own sign-ins, Jr Staff included, on either sign-in. */
export function isDancerSelfSignIn(account: SelfSignInAccount | null | undefined): boolean {
  if (!account) return false;
  if (isDancerChildLogin(account)) return true;
  return isOwnJrStaffSignIn({
    uid: '',
    role: text(account.role) || null,
    status: text(account.status) || null,
    studentId: text(account.studentId) || null,
  } satisfies JrStaffAliasAccount);
}
